// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"purify_footerCta__footerContainer--1_9eG","eachFooter":"purify_footerCta__eachFooter--My0zv"};